// const FACEBOOK_API_URL = process.env.REACT_APP_FACEBOOK_LEAD_ADS_API_URL;

// const parseResponse = async (response) => {
//     const contentType = response.headers.get("content-type");

//     let result;

//     if (contentType?.includes("application/json")) {
//         result = await response.json();
//     } else {
//         const text = await response.text();
//         result = {
//             message: text || "Unexpected API response.",
//         };
//     }

//     if (!response.ok) {
//         throw new Error(result?.message || "Facebook API request failed.");
//     }

//     if (result?.success === false || result?.status === false) {
//         throw new Error(result?.message || "Facebook API request failed.");
//     }

//     return result;
// };

// export const connectFacebook = async ({ userId, code }) => {
//     if (!code) {
//         throw new Error("Facebook authorization code is missing.");
//     }
//     if (!userId) {
//         throw new Error("User ID is missing.");
//     }

//     const response = await fetch(FACEBOOK_API_URL, {
//         method: "POST",
//         headers: {
//             "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//             method: "connectFacebook",
//             userId,
//             code
//         }),
//     });

//     return parseResponse(response);
// };



const FACEBOOK_API_URL = process.env.REACT_APP_FACEBOOK_LEAD_ADS_API_URL;

const parseResponse = async (response) => {
    const contentType = response.headers.get("content-type");

    let result;

    if (contentType?.includes("application/json")) {
        result = await response.json();
    } else {
        const text = await response.text();
        result = {
            message: text || "Unexpected API response.",
        };
    }

    if (!response.ok) {
        throw new Error(result?.message || "Facebook API request failed.");
    }

    if (result?.success === false || result?.status === false) {
        throw new Error(result?.message || "Facebook API request failed.");
    }

    return result;
};

export const connectFacebook = async ({ userId, code }) => {
    if (!code) {
        throw new Error("Facebook authorization code is missing.");
    }
    if (!userId) {
        throw new Error("User ID is missing.");
    }

    const response = await fetch(FACEBOOK_API_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            method: "connectFacebook",
            userId,
            code
        }),
    });

    return parseResponse(response);
};

export const fetchFacebookAccountInfo = async ({ userId }) => {
    if (!userId) {
        throw new Error("User ID is missing.");
    }

    const response = await fetch(FACEBOOK_API_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            method: "fetchFacebookAccountInfo",
            userId
        }),
    });

    return parseResponse(response);
};

// Fetches Facebook Lead Ad forms for every Page connected under this user.
export const fetchFacebookLeadForms = async ({ userId }) => {
    if (!userId) {
        throw new Error("User ID is missing.");
    }

    const response = await fetch(FACEBOOK_API_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            method: "fetchFacebookLeadForms",
            userId
        }),
    });

    return parseResponse(response);
};

// Checks whether this user already has at least one Contact List. A
// Contact List is the mandatory destination for imported Facebook leads.
export const checkContactListStatus = async ({ userId }) => {
    if (!userId) {
        throw new Error("User ID is missing.");
    }

    const response = await fetch(FACEBOOK_API_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            method: "checkContactListStatus",
            userId
        }),
    });

    return parseResponse(response);
};

export const disconnectFacebook = async ({ userId }) => {
    if (!userId) {
        throw new Error("User ID is missing.");
    }

    const response = await fetch(FACEBOOK_API_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            method: "disconnectFacebook",
            userId
        }),
    });

    return parseResponse(response);
};